import { IWithWorksheetInjectedProps } from 'Components/Worksheets/Core';
import React from 'react';
import { NamePrefixModifier, withInjectedProps } from '../../../../../Core/InjectedPropsContext';
import AsLiquidLimitCuringSection from '../LiquidLimitCuringSection';
import LiquidLimitEquipmentDetailsSection from '../LiquidLimitEquipmentDetailsSection';
import AsLiquidLimitFourPointDeterminationSection from './LiquidLimitFourPointDeterminationSection';
import AsLiquidLimitFourPointResultsSection from './LiquidLimitFourPointResultsSection';

let AsLiquidLimitFourPointSectionWithShrinkage: React.FC<IWithWorksheetInjectedProps> = ({
  createWorksheetSelector,
}) => {
  return (
    <>
      <NamePrefixModifier appendNamePrefix="LiquidLimit">
        <LiquidLimitEquipmentDetailsSection />
        <AsLiquidLimitCuringSection />
        <AsLiquidLimitFourPointDeterminationSection hideLinearShrinkageFields={false} />
      </NamePrefixModifier>
      <AsLiquidLimitFourPointResultsSection />
    </>
  );
};

AsLiquidLimitFourPointSectionWithShrinkage = withInjectedProps(AsLiquidLimitFourPointSectionWithShrinkage);

export { AsLiquidLimitFourPointSectionWithShrinkage };
export default AsLiquidLimitFourPointSectionWithShrinkage;
